export enum StepperStatusTypes {
  Working = 'STEPPER_WORKING',
  Success = 'STEPPER_SUCCESS',
  Error = 'STEPPER_ERROR',
}

export enum IndividualStepTypes {
  Prompting = 'STEP_PROMPTING',
  Waiting = 'STEP_WAITING',
  Working = 'STEP_WORKING',
  Success = 'STEP_SUCCESS',
  Error = 'STEP_ERROR',
}
